import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { User, UserRoleKey } from "@/features/system/types";

import { user } from "@/utils/firebase/user";
import { identifySummitUserForGoogleAnalytics } from "@/utils/googleAnalytics";
import { identifyHeapUser } from "@/utils/heap";
import { identifyMixpanelUser } from "@/utils/mixpanel";
import { baseClient } from "@/utils/remote";

import { API_STALE_TIME } from "../constants";

type ExtendedUser = Omit<User, "role"> & {
  role: UserRoleKey | "ADMIN";
};

interface CurrentUserResponse {
  user: ExtendedUser;
}

export const useCurrentUserQuery = (
  options?: Omit<UseQueryOptions<CurrentUserResponse>, "queryKey" | "queryFn">,
) => {
  return useQuery<CurrentUserResponse>({
    queryKey: ["currentUser"],
    queryFn: async () => {
      const res = await baseClient.get(`users/${user.email}`);
      if (res.data?.user?.email) {
        // Fire-and-forget: GA hashing must not block the current-user query.
        void identifySummitUserForGoogleAnalytics(res.data.user);
        identifyHeapUser(res.data.user);
        identifyMixpanelUser(res.data.user);
      }
      return res.data;
    },
    staleTime: API_STALE_TIME,
    ...options,
  });
};
